import React from 'react';
import { Edit, ReferenceInput, SimpleForm, TextInput } from 'react-admin';
import { AutocompleteInput, ImageField } from 'react-admin';

import {
   Filter,
   TopToolbar,
   ImageInput,
   CloneButton,
   ShowButton,
   TabbedForm,
   FormTab,
   Toolbar,
   SaveButton,
   required,
   List,
   Show,
   RichTextField,
   SimpleShowLayout,
   Create,
   Datagrid,
   TextField,
   EditButton,
   DeleteButton,
   DeleteWithConfirmButton,
   BooleanInput,
   SelectInput,
   BooleanField,
   DateField,
   minLength
} from 'react-admin';
import RichTextInput from 'ra-input-rich-text';
import { DateTimeInput } from 'react-admin';
import PostTitle from '../PostTitle';
import ListActions from '../ListActions';

const WordOfDayFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search by Content" source="body" alwaysOn />
        <ReferenceInput label="Authors" source="id" reference="favreads_authors" allowEmpty>
            <SelectInput optionText="name.en" />
        </ReferenceInput>
        <ReferenceInput label="Source" source="id" reference="favreads_quote_sources" allowEmpty>
            <SelectInput optionText="name.en" />
        </ReferenceInput>
        <BooleanInput source="is_active" label="Active?" allowEmpty />
    </Filter>
);

export const WordOfDayList = props => (
	<List filters={<WordOfDayFilter />} actions={<ListActions />} {...props}>
       <Datagrid rowClick="edit">
	  		<ImageField source="thumbnail" title="title"  label="Thumbnail"/>
            <RichTextField source="body"  label="Body"/>
		    <RichTextField source="short_description.en" label="Short Description" />
            <RichTextField source="description.en" label="Description-English" />
            <BooleanField source="is_active" label="Is Active?" />
            <DateField source="created_at" />
            <ShowButton label="" />
		    <EditButton label="" />
		    <DeleteWithConfirmButton label="" redirect={false} />
       </Datagrid>
   </List>
);
const CustomToolbar = props => (
    <Toolbar {...props}>
        <SaveButton />
        <DeleteButton undoable={false} />
    </Toolbar>
);
const EditActions = ({ basePath, data, hasShow }) => (
    <TopToolbar>
        <CloneButton
            className="button-clone"
            basePath={basePath}
            record={data}
        />
        {hasShow && <ShowButton basePath={basePath} record={data} />}
    </TopToolbar>
);
export const WordOfDayEdit = props => (
   <Edit actions={<EditActions />} {...props}>
      <TabbedForm warnWhenUnsavedChanges>
	    <FormTab label="Summary">
           <TextInput disabled source="id"/>
			<RichTextInput source="body" label="Body" />
			<TextInput source="thumbnail" fullWidth={true}/>
			<TextInput source="backdrop" fullWidth={true}/>
            <TextInput source="icon_header" label="Header Icon" fullWidth={true} />
            <TextInput source="icon_footer" label="Footer Icon" fullWidth={true} />
            <TextInput source="icon_divider" label="Divider Icon" fullWidth={true} />
			<BooleanInput source="is_active"/>
		</FormTab>
		<FormTab label="Translations">
			<TextInput
				source="sub_body.en"
				label="Subbody-English"
				fullWidth={true}
				validate={required()}
			/>
			<TextInput
				source="sub_body.hi"
				label="Subbody-Hindi"
				fullWidth={true}
				validate={required()}
			/>
			<RichTextInput source="short_description.en" label="Summary-English" />
  		    <RichTextInput source="short_description.hi" label="Summary-Hindi" />
			<RichTextInput source="description.en" label="Description-English" />
  		    <RichTextInput source="description.hi" label="Description-Hindi" />
 		</FormTab>
	  </TabbedForm>
   </Edit>
);

export const WordOfDayShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="body" />
	  <ImageField source="thumbnail" title="title" />
      <RichTextField source="short_description.en" />
      <RichTextField source="description.en" />
    </SimpleShowLayout>
  </Show>
);

export const WordOfDayCreate = props => (
   <Create {...props}>
	<TabbedForm warnWhenUnsavedChanges>
	    <FormTab label="Summary">
            <TextInput disabled source="id"/>
			<RichTextInput source="body" label="Body" />
            <TextInput source="thumbnail" fullWidth={true}/>
			<TextInput source="backdrop" fullWidth={true}/>
			<TextInput source="icon_header" label="Header Icon" fullWidth={true} />
            <TextInput source="icon_footer" label="Footer Icon" fullWidth={true} />
            <TextInput source="icon_divider" label="Divider Icon" fullWidth={true} />
            <ReferenceInput label="Language" source="languageId" reference="favreads_languages">
				<AutocompleteInput optionText="name.en" />
			</ReferenceInput>
			<BooleanInput source="is_active"/>
		</FormTab>
		<FormTab label="Translations">
			<TextInput
				source="sub_body.en"
				label="Subbody-English"
				fullWidth={true}
				validate={required()}
			/>
			<TextInput
				source="sub_body.hi"
				label="Subbody-Hindi"
				fullWidth={true}
				validate={required()}
			/>
			<RichTextInput source="short_description.en" label="Summary-English" />
  		    <RichTextInput source="short_description.hi" label="Summary-Hindi" />
			<RichTextInput source="description.en" label="Description-English" />
  		    <RichTextInput source="description.hi" label="Description-Hindi" />
 		</FormTab>
	  </TabbedForm>
   </Create>
);